import { Flex } from "@chakra-ui/react";
import styles from "./Body.module.scss";
import Roadmap from "./Roadmap/Roadmap";
import About from "./About/About";
import Feature from "./Feature/Feature";
import Community from "./Community/Community";
import ShowCase from "./ShowCase/ShowCase";

export default function Body() {
  return (
    <Flex className={styles.container} flexDirection={"column"}>
      <About />
      <Feature />
      <ShowCase />
      <Roadmap />
      <Community />
    </Flex>
  );
}
